import Lottie from 'lottie-web'

{
    const icons = document.getElementsByClassName('card__icon__set')
    for (let i = 0; i < icons.length; i++) {
        let iconEl = icons[i].getAttribute('data-icon')
        if (iconEl !== null) {

            Lottie.loadAnimation({
                container: icons[i], // the dom element that will contain the animation
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: '/app/themes/zenith/static/js/json/' + iconEl + '.json' // the path to the animation json (Bedrock uses /app)
            })
        }
    }
}
